{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Действия доступны.",
  "actionbar.clearSelection": "Очистить выбор",
  "actionbar.selected": "{count, plural, =0 {Не выбрано} other {Выбрано #}}",
  "actionbar.selectedAll": "Выбрано все",
  "breadcrumbs.more": "Дополнительные элементы",
  "button.pending": "в ожидании",
  "combobox.noResults": "Результаты отсутствуют",
  "contextualhelp.help": "Справка",
  "contextualhelp.info": "Информация",
  "dialog.alert": "Предупреждение",
  "dialog.dismiss": "Пропустить",
  "dropzone.replaceMessage": "Перетащите файл для замены",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Ошибка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(дополнительно)",
  "label.(required)": "(обязательно)",
  "menu.moreActions": "Дополнительные действия",
  "notificationbadge.indicatorOnly": "Новая активность",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Выбрать…",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.loading": "Загрузка...",
  "table.loadingMore": "Дополнительная загрузка...",
  "table.resizeColumn": "Изменить размер столбца",
  "table.sortAscending": "Сортировать по возрастанию",
  "table.sortDescending": "Сортировать по убыванию",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показать меньше",
  "tag.noTags": "Нет",
  "tag.showAllButtonLabel": "Показать все ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
